import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-3 mt-4 bg-white border border-primary shadow rounded-2xl p-8" }
const _hoisted_2 = { class: "flex items-center justify-center" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary font-semibold" }, " Incoming talent ", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "flex items-center justify-center uppercase" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserCard = _resolveComponent("UserCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UserCard, {
      firstName: _ctx.talent.first_name,
      lastName: _ctx.talent.last_name,
      position: _ctx.talent.job_title,
      id: _ctx.talent.id
    }, null, 8, ["firstName", "lastName", "position", "id"]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.talent.entry_day)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, " Entry Date: " + _toDisplayString(_ctx.talent.entry_day), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.currency === 'usd')
        ? (_openBlock(), _createElementBlock("span", _hoisted_8, " $" + _toDisplayString(((_ctx.talent.salary.monthly * _ctx.exchange_rate) / 100).toLocaleString(
            undefined,
            { minimumFractionDigits: 2, maximumFractionDigits: 2 }
          )) + " " + _toDisplayString(_ctx.currency), 1))
        : _createCommentVNode("", true),
      (_ctx.currency === 'mxn')
        ? (_openBlock(), _createElementBlock("span", _hoisted_9, " $" + _toDisplayString((_ctx.talent.salary.monthly / 100).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })) + " " + _toDisplayString(_ctx.currency), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}